/* OCP collection — AJAX filtering & sort via the Shopify Section Rendering API (no full page reload).
 * Progressive enhancement over the GET forms/links rendered by sections/ocp-collection.liquid:
 *  - desktop sidebar auto-applies on change; mobile sheet applies on its "Apply" submit
 *  - chips / "Clear all" / segment tabs / pagination are real links, intercepted here
 *  - sort <select> and the mobile sort buttons re-sort while preserving active filters
 * Each interaction fetches `{collection.url}?{params}&section_id={id}`, swaps the [data-ocp-swap]
 * regions in place, and history.pushState's the clean URL. Falls back to a full navigation on error. */
(function () {
  function root() { return document.querySelector('.ocp-collection-page[data-section-id]'); }
  if (!root()) return;

  var seq = 0;
  var debounceTimer;

  function sectionId() { var r = root(); return r ? r.getAttribute('data-section-id') : null; }

  function formParams(form) {
    var p = new URLSearchParams();
    Array.prototype.forEach.call(form.elements || [], function (el) {
      if (!el.name || el.disabled) return;
      if (el.type === 'checkbox' || el.type === 'radio') { if (el.checked) p.append(el.name, el.value); }
      else if (el.value !== '') p.append(el.name, el.value);
    });
    return p;
  }

  function urlFromParams(params) {
    var base = (root() && root().getAttribute('data-collection-url')) || location.pathname;
    var qs = params.toString();
    return base + (qs ? '?' + qs : '');
  }

  function sortValue() { var s = document.querySelector('[data-ocp-sort]'); return s ? s.value : ''; }
  // current sort applied to a set of params (so filtering preserves the active sort)
  function withSort(params) { params.delete('sort_by'); var v = sortValue(); if (v) params.set('sort_by', v); return params; }
  // the live (post-swap, in-sync) filter selection — so sorting preserves the active filters
  function liveFilterParams() {
    var ff = document.querySelector('[data-ocp-filter-form]');
    var p = ff ? formParams(ff) : new URLSearchParams();
    p.delete('sort_by');
    return p;
  }

  function setLoading(on) {
    var g = document.querySelector('[data-ocp-swap="grid"]');
    if (g) { g.classList.toggle('is-loading', on); g.setAttribute('aria-busy', on ? 'true' : 'false'); }
  }

  // Preserve which filter accordions the shopper has open across a swap (matched by their label text).
  function openDetailLabels() {
    var out = [];
    document.querySelectorAll('[data-ocp-swap^="groups-"] details[open] > summary').forEach(function (s) { out.push(s.textContent.trim()); });
    return out;
  }
  function restoreOpenDetails(labels) {
    if (!labels.length) return;
    document.querySelectorAll('[data-ocp-swap^="groups-"] details').forEach(function (d) {
      var s = d.querySelector('summary');
      if (s && labels.indexOf(s.textContent.trim()) >= 0) d.open = true;
    });
  }

  function swap(doc) {
    var openLabels = openDetailLabels();
    document.querySelectorAll('[data-ocp-swap]').forEach(function (el) {
      var fresh = doc.querySelector('[data-ocp-swap="' + el.getAttribute('data-ocp-swap') + '"]');
      if (fresh) el.innerHTML = fresh.innerHTML;
    });
    restoreOpenDetails(openLabels);
    setTimeout(function () { document.dispatchEvent(new CustomEvent('ocp:collection-swapped')); }, 0);
    // keep the visible "Sort by: X" labels in sync with the active sort
    var sel = document.querySelector('[data-ocp-sort]');
    if (sel && sel.options[sel.selectedIndex]) {
      var name = sel.options[sel.selectedIndex].textContent;
      document.querySelectorAll('[data-bind="active-sort-label"]').forEach(function (e) { e.textContent = name; });
    }
  }

  // ---- Swatch-pollution guard (2026-07-10) --------------------------------------------------------
  // Shopify's price filter matches a product when ANY variant is in range — so $0.99 swatch variants
  // put $20+ fabrics into "Less than $5". Every variant carries custom.is_sample (swatch=true,
  // purchasable=false; registered as a Search & Discovery filter), and we silently pair every price
  // param with is_sample=false so only REAL purchasable prices match. The param stays out of the
  // address bar (clean URLs) and out of the filter UI (theme skips the group + chip).
  var SAMPLE_PARAM = 'filter.v.m.custom.is_sample';
  function stripSampleParam(url) {
    var u = new URL(url, location.origin);
    u.searchParams.delete(SAMPLE_PARAM);
    return u.pathname + u.search;
  }
  function withSampleGuard(url) {
    var u = new URL(url, location.origin);
    u.searchParams.delete(SAMPLE_PARAM);
    // S&D does not apply variant-metafield filters on /search (is_sample matches nothing there,
    // zeroing every result), so the guard rides along on collection URLs only. Trade-off: the
    // cheapest price buckets on search can show swatch-priced matches.
    if (/(^|\/)search$/.test(u.pathname)) return u.pathname + u.search;
    var hasPrice = false;
    u.searchParams.forEach(function (v, k) { if (k.indexOf('filter.v.price') === 0) hasPrice = true; });
    if (hasPrice) u.searchParams.append(SAMPLE_PARAM, 'false');
    return u.pathname + u.search;
  }

  function navigate(url, push) {
    var mySeq = ++seq;
    setLoading(true);
    url = stripSampleParam(url); // address bar + history stay clean
    var guarded = withSampleGuard(url); // fetch carries is_sample=false alongside any price filter
    var fetchUrl = guarded + (guarded.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId());
    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (mySeq !== seq) return; // a newer request superseded this one
        swap(new DOMParser().parseFromString(html, 'text/html'));
        if (push !== false) history.pushState({ ocpCollection: true }, '', url);
        setLoading(false);
        var listing = document.querySelector('.listing');
        if (push !== false && listing && listing.getBoundingClientRect().top < -4) listing.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function () { window.location.href = url; });
  }

  function closeSheet(sheetEl, action) {
    if (!sheetEl) return;
    var btn = sheetEl.querySelector('[data-action="' + action + '"]');
    if (btn) btn.click();
  }

  // ---- Width buckets (Review 08/07): each bucket checkbox represents a SET of raw width_in values. It
  // has no `name`, so we mirror its values as hidden inputs INSIDE the filter form. That way the normal
  // apply path picks them up in formParams — desktop auto-applies on change; the mobile sheet includes
  // them when Apply is pressed (previously the sheet's Apply dropped the width entirely). Capture phase so
  // the hidden inputs exist before the generic change handler reads the form; propagation is NOT stopped.
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.hasAttribute || !cb.hasAttribute('data-width-bucket')) return;
    var form = cb.closest('[data-ocp-filter-form]');
    if (!form) return;
    var param = cb.getAttribute('data-width-param');
    var key = cb.getAttribute('data-width-values') || '';
    var vals = key.split(',').filter(Boolean);
    Array.prototype.forEach.call(form.querySelectorAll('input[type="hidden"][data-width-hidden="' + key + '"]'), function (el) { el.remove(); });
    if (cb.checked) {
      vals.forEach(function (v) {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = param; h.value = v; h.setAttribute('data-width-hidden', key);
        form.appendChild(h);
      });
    }
  }, true);

  // Review #5 (items 3/4): Pattern type is single-valued — Pattern AND Solid together match nothing
  // ("No products found" dead end). The seg tabs already enforce exclusivity; enforce it on the
  // CHECKBOX path too: ticking one pattern_type box unticks its sibling. Capture phase so the state
  // is settled before the generic change handler serializes the form.
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || cb.type !== 'checkbox' || !cb.checked || !cb.name || cb.name.indexOf('pattern_type') === -1) return;
    var form = cb.closest('[data-ocp-filter-form]');
    if (!form) return;
    Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"][name="' + cb.name + '"]'), function (o) {
      if (o !== cb) o.checked = false;
    });
  }, true);

  // ---- filter checkbox / price change: desktop sidebar auto-applies; mobile sheet waits for Apply ----
  document.addEventListener('change', function (e) {
    var t = e.target;
    var filterForm = t.closest && t.closest('[data-ocp-filter-form]');
    if (filterForm && !filterForm.closest('.sheet')) {
      e.preventDefault();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { navigate(urlFromParams(withSort(formParams(filterForm))), true); }, 300);
      return;
    }
    var sortSel = t.closest && t.closest('[data-ocp-sort]');
    if (sortSel) {
      e.preventDefault();
      var p = liveFilterParams(); p.set('sort_by', sortSel.value); // keep active filters when sorting
      navigate(urlFromParams(p), true);
      return;
    }
  });

  // ---- Apply buttons (desktop sidebar + mobile sheet) ----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ocp-filter-form], [data-ocp-sort-form]');
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    navigate(urlFromParams(withSort(formParams(form))), true);
    if (form.closest('.sheet')) closeSheet(form.closest('.sheet'), 'close-filters');
  }, true);

  // ---- "Load more": append the next (filtered) page in place, never reload ----
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var more = e.target.closest && e.target.closest('[data-ocp-loadmore]');
    if (!more) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var nextUrl = more.getAttribute('href');
    if (!nextUrl || more.classList.contains('is-loading')) return;
    more.classList.add('is-loading');
    var fetchUrl = nextUrl + (nextUrl.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId());
    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshGrid = doc.querySelector('[data-ocp-swap="grid"]');
        var grid = document.querySelector('[data-ocp-swap="grid"]');
        if (freshGrid && grid) { while (freshGrid.firstChild) grid.appendChild(freshGrid.firstChild); } // append next page's cards
        var pag = document.querySelector('[data-ocp-swap="pagination"]');
        var freshPag = doc.querySelector('[data-ocp-swap="pagination"]');
        if (pag) pag.innerHTML = freshPag ? freshPag.innerHTML : ''; // new "Load more" (page+1) or nothing if last
        // Review 09/07: tell the rest of the page new cards were appended — the swatch-image prewarm
        // re-observes them and the sticky rail recomputes its height. (Full swaps fire this from swap().)
        document.dispatchEvent(new CustomEvent('ocp:collection-swapped'));
        // URL intentionally left at the filter state (not ?page=N) so a refresh shows page 1 + Load more,
        // never a lone middle page. The button's own href (from the swapped pagination) drives the next fetch.
      })
      .catch(function () { window.location.href = nextUrl; });
  }, true);

  // ---- links: chips remove, "Clear all", segment tabs, numbered pagination ----
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('[data-ocp-filter-link], [data-ocp-swap="pagination"] a:not([data-ocp-loadmore])');
    if (!link || !root().contains(link)) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    // Review 07/07 (Filters #2): "All products" clears every availability param (native stock facet +
    // the availability_status metafield) so it truly resets the Availability group.
    if (link.hasAttribute('data-avail-clear')) {
      var ua = new URL(href, location.origin);
      Array.prototype.slice.call(ua.searchParams.keys()).forEach(function (k) {
        if (k.indexOf('availability') !== -1) ua.searchParams.delete(k);
      });
      href = ua.pathname + ua.search;
    }
    // Review 07/07 (Filters #14): segment tabs (All / Pattern / Solid) are mutually exclusive. Keep only
    // the clicked value of the seg param, dropping any sibling value so Pattern and Solid can't both be on.
    var segParam = link.getAttribute('data-seg-param');
    if (segParam) {
      var u = new URL(href, location.origin);
      u.searchParams.delete(segParam);
      var segVal = link.getAttribute('data-seg-value');
      if (segVal) u.searchParams.append(segParam, segVal);
      href = u.pathname + u.search;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    navigate(href, true);
  }, true);

  // ---- mobile sort buttons: apply chosen sort, keep active filters ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sort-mobile]');
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var p = liveFilterParams(); p.set('sort_by', btn.getAttribute('data-sort-mobile')); // keep filters when mobile-sorting
    navigate(urlFromParams(p), true);
    closeSheet(btn.closest('.sheet'), 'close-sort');
  }, true);

  // ---- back / forward ----
  window.addEventListener('popstate', function () { navigate(location.pathname + location.search, false); });

  // Direct/shared URL with a price filter: the server rendered WITHOUT the sample guard (it's added at
  // fetch time), so re-render the grid once through navigate() to apply it.
  if (location.search.indexOf('filter.v.price') !== -1) {
    navigate(location.pathname + location.search, false);
  }
})();

/* ---- Sticky filter rail (Review 09/07, Filters #2) ------------------------------------------------
 * The client wants the filter rail to scroll WITH the page until its end, then pin while the (longer)
 * product grid keeps scrolling — not an internal scrollbar, and not pinned-at-top from the start (which
 * hides the bottom filters on a tall rail). CSS can't know the rail height, so we compute the sticky
 * `top` here: a rail shorter than the viewport pins at a small top gap; a taller rail gets a NEGATIVE
 * top (= viewportH - railH - gap), so `position:sticky` lets the whole rail scroll into view first and
 * then sticks bottom-anchored. Recomputed on resize, on accordion open/close, and after AJAX swaps. */
(function () {
  var filters = document.querySelector('.ocp-collection-page .filters');
  if (!filters) return;
  var TOP_GAP = 24, BOTTOM_GAP = 24, raf;
  function update() {
    if (window.innerWidth < 901) { filters.style.removeProperty('--filters-sticky-top'); return; }
    var vh = window.innerHeight, fh = filters.offsetHeight;
    var top = (fh + TOP_GAP <= vh) ? TOP_GAP : (vh - fh - BOTTOM_GAP);
    filters.style.setProperty('--filters-sticky-top', top + 'px');
  }
  function schedule() { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }
  update();
  window.addEventListener('resize', schedule);
  // opening/closing a filter accordion changes the rail height → recompute the pin offset
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('sheet-group')) schedule();
  }, true);
  document.addEventListener('ocp:collection-swapped', schedule);
})();
